import { Directive, HostListener, ElementRef, Renderer2, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimInput]',
  standalone: true
})
export class TrimInputDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  @HostListener('blur')
  onBlur() {
    const value = this.el.nativeElement.value;

    if (typeof value === 'string' && value.length > 0) {
      const trimmedValue = value.trim();

      if (value !== trimmedValue) {
        if (this.ngControl && this.ngControl.control) {
          this.ngControl.control.setValue(trimmedValue);
        } else {
          this.renderer.setProperty(this.el.nativeElement, 'value', trimmedValue);
        }
      }
    }
  }
}